import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Alert,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EventContext } from "../../../../contexts/EventContext";

import formatCamelCase from "../../../../utilities/formatCamelCase";
import request from "../../../../utilities/requests";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NewQuestionDialog = ({ open, close }) => {
  const { userData } = React.useContext(EventContext);
  const [categories, setCategories] = React.useState([]);
  const [question, setQuestion] = React.useState({
    question: "",
    questionType: "",
    category: "",
    lowerRangeLabel: "",
    lowerRangeValue: "",
    upperRangeLabel: "",
    upperRangeValue: "",
    choice1: "",
    choice2: "",
    choice3: "",
    choice4: "",
    choice5: "",
  });

  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (open) {
      console.log("open");
      setQuestion({
        question: "",
        questionType: "",
        category: "",
        lowerRangeLabel: "",
        lowerRangeValue: "",
        upperRangeLabel: "",
        upperRangeValue: "",
        choice1: "",
        choice2: "",
        choice3: "",
        choice4: "",
        choice5: "",
      });
      setError(null);
      if (categories.length === 0) {
        getCategories();
      }
    }
  }, [open]);

  const getCategories = async () => {
    const result = await request("matchmaking/question/categories");
    if (result.success) {
      setCategories(result.categories);
    }
  };

  const handleChange = (field, value) => {
    question[field] = value;
    setQuestion({ ...question });
  };

  const renderOptions = () => {
    if (question.questionType === "choice") {
      return (
        <>
          <Grid item>
            <TextField
              fullWidth
              label="Choice 1"
              value={question.choice1}
              onChange={(e) => handleChange("choice1", e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="Choice 2"
              value={question.choice2}
              onChange={(e) => handleChange("choice2", e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="Choice 3"
              value={question.choice3}
              onChange={(e) => handleChange("choice3", e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="Choice 4"
              value={question.choice4}
              onChange={(e) => handleChange("choice4", e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="Choice 5"
              value={question.choice5}
              onChange={(e) => handleChange("choice5", e.target.value)}
            />
          </Grid>
        </>
      );
    } else if (question.questionType === "range") {
      return (
        <>
          <Grid item>
            <TextField
              fullWidth
              label="Lower Range Label"
              value={question.lowerRangeLabel}
              onChange={(e) => handleChange("lowerRangeLabel", e.target.value)}
            />
          </Grid>
          <Grid item>
            <FormControl fullWidth>
              <InputLabel>Lower Range Value</InputLabel>
              <Select
                value={question?.lowerRangeValue}
                label="Lower Range Value"
                autoWidth
                onChange={(e) =>
                  handleChange("lowerRangeValue", e.target.value)
                }
              >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="Upper Range Label"
              value={question.upperRangeLabel}
              onChange={(e) => handleChange("upperRangeLabel", e.target.value)}
            />
          </Grid>
          <Grid item>
            <FormControl fullWidth>
              <InputLabel>Upper Range Value</InputLabel>
              <Select
                value={question?.upperRangeValue}
                label="Upper Range Value"
                autoWidth
                onChange={(e) =>
                  handleChange("upperRangeValue", e.target.value)
                }
              >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </>
      );
    }

    return <></>;
  };

  const handleSave = async () => {
    let error;

    if (!question.questionType) {
      error = "Please select a question type.";
    } else if (!question.category){
      error = "Please select a question category.";
    }else if (!question.question) {
      error = "Please enter a question to be asked";
    } else if (
      question.questionType === "choice" &&
      (!question.choice1 ||
      !question.choice2 ||
      !question.choice3)
    ) {
      error = "Please enter at least 3 possible answer choices";
    } else if (question.questionType === "range") {
      if (!question.lowerRangeLabel) {
        error = "Please enter a label for the lower range";
      } else if (!question.lowerRangeValue) {
        error = "Please select a value for the lower range";
      } else if (!question.upperRangeLabel) {
        error = "Please enter a label for the upper range";
      } else if (!question.upperRangeValue) {
        error = "Please select a value for the upper range";
      } else if (question.lowerRangeValue > question.upperRangeValue) {
        error = "The lower range value must be less than the upper range value";
      }
    }
    if (error) {
      setError(error);
      return;
    } else {
      setError(null);
    }

    const result = await request(
      "matchmaking/question/create",
      "post",
      question
    );
    if (result.success) {
      close();
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={close}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              New Question
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container direction="column" spacing={3} style={{ padding: 20 }}>
          {error ? (
            <Grid item>
              <Alert severity="error">{error}</Alert>
            </Grid>
          ) : (
            <></>
          )}

          <Grid item>
            <FormControl fullWidth>
              <InputLabel>Question Type</InputLabel>
              <Select
                value={question.questionType}
                label={"Question Type"}
                onChange={(e) => handleChange("questionType", e.target.value)}
              >
                <MenuItem value={"yesno"}>Yes/No</MenuItem>
                <MenuItem value={"choice"}>Choice</MenuItem>
                <MenuItem value={"range"}>Range</MenuItem>
                <MenuItem value={"text"}>Text</MenuItem>

              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl fullWidth>
              <InputLabel>Category</InputLabel>
              <Select
                value={question.category}
                label={"Category"}
                onChange={(e) => handleChange("category", e.target.value)}
              >
                {categories.map((c) => {
                  return (
                    <MenuItem key={c} value={c}>
                      {formatCamelCase(c)}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <TextField
              fullWidth
              label="Question"
              value={question.question}
              onChange={(e) => handleChange("question", e.target.value)}
            />
          </Grid>

          {renderOptions()}
          <Grid item>
            <Button
              variant="outlined"
              onClick={handleSave}
              style={{ width: "100%" }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default NewQuestionDialog;
